import { SVGProps } from "react";

export default function PostPlaylistIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, stroke = "#292D32", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M21.3668 18.02L21.2668 19.3C21.1168 20.83 20.9968 22 18.2868 22H5.70684C2.99684 22 2.87684 20.83 2.72684 19.3L2.32684 14.3C2.24684 13.47 2.50684 12.7 2.97684 12.11C2.98684 12.1 2.98684 12.1 2.99684 12.09C3.54684 11.42 4.37684 11 5.30684 11H18.6868C19.6168 11 20.4368 11.42 20.9768 12.07C20.9868 12.08 20.9968 12.09 20.9968 12.1C21.4868 12.69 21.7568 13.46 21.6668 14.3"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 11.4303V6.28027C3.5 2.88027 4.35 2.03027 7.75 2.03027H9.02C10.29 2.03027 10.58 2.41027 11.06 3.05027L12.33 4.75027C12.65 5.17027 12.84 5.43027 13.69 5.43027H16.24C19.64 5.43027 20.49 6.28027 20.49 9.68027V11.4703"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.42969 17H14.5697"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
